import config from '@/config'

const urls = {
  single: 'supplier',
  multiple: 'suppliers',
}

export default {
  resourceUrlSingle: `${config.resourceHost}${urls.single}`,
  resourceUrlMultiple: `${config.resourceHost}${urls.multiple}`,
  findCity: `${config.resourceHost}find/city/`,
  fetchDefaultSupplierModelUrl: `${config.resourceHost}supplier/new`,
  supplierListSetting: `${config.resourceHost}setting/userlist/supplier`,
  deleteUrl: `${config.resourceHost}supplier`,

  clientUrl: urls,
  routes: {
    details: `${config.resourceHost}${urls.single}${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  options: {
    list: {
      name: urls.multiple,
      quickfilters: {
        models: [
          { name: 'all', title: 'Alle' },
        ],
      },
      defaultSort: { property: 'name', desc: false },
    },
    history: {
      pagination: {
        page: 1,
        pageSize: 5,
      },
      defaultSort: {
        property: 'date', desc: true,
      },
      quickfilters: {
        models: [
          { name: 'all', title: 'Alle', filter: 'all' },
        ],
      },
    },
  },
}
